import React, { useState } from 'react';
import './ExerciseSteps.css';

const ReflectionStep = ({ step, onContinue }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [customReflection, setCustomReflection] = useState('');

  const handleOptionToggle = (option) => {
    setSelectedOptions(prev => 
      prev.includes(option)
        ? prev.filter(item => item !== option)
        : [...prev, option]
    );
  };

  const handleContinue = () => {
    const response = {
      selectedOptions,
      customReflection: customReflection.trim()
    };
    onContinue(response);
  };

  const canContinue = selectedOptions.length > 0 || customReflection.trim();

  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        <div className="step-text">
          {step.content}
        </div>
        
        <div className="options-container">
          {step.options.map((option, index) => (
            <button
              key={index}
              className={`option-button ${selectedOptions.includes(option) ? 'selected' : ''}`}
              onClick={() => handleOptionToggle(option)}
            >
              {option}
            </button>
          ))}
        </div>

        <div className="custom-reflection">
          <label className="reflection-label">
            ¿Algo más que quieras agregar?
          </label>
          <textarea
            className="reflection-input"
            value={customReflection}
            onChange={(e) => setCustomReflection(e.target.value)}
            placeholder="Escribe tu reflexión personal aquí..."
            rows={3}
          />
        </div>
      </div>
      
      <div className="step-actions">
        <button 
          className={`step-button ${canContinue ? 'primary' : 'disabled'}`}
          onClick={handleContinue}
          disabled={!canContinue}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default ReflectionStep; 